import { useEffect, useState } from 'react';

interface InstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

function installed(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches ||
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
}

/** Acceso móvil a la instalación PWA: abre Alexia sin la barra del navegador. */
export function InstallAppButton(): JSX.Element | null {
  const [prompt, setPrompt] = useState<InstallPromptEvent | null>(null);
  const [instructions, setInstructions] = useState(false);
  const [isInstalled, setInstalled] = useState(installed);

  useEffect(() => {
    const onPrompt = (event: Event) => {
      event.preventDefault();
      setPrompt(event as InstallPromptEvent);
    };
    const onInstalled = () => setInstalled(true);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (isInstalled) return null;

  const install = async () => {
    if (!prompt) {
      setInstructions((value) => !value);
      return;
    }
    await prompt.prompt();
    const choice = await prompt.userChoice;
    if (choice.outcome === 'accepted') setInstalled(true);
    setPrompt(null);
  };

  const apple = /iPad|iPhone|iPod/.test(navigator.userAgent);
  return (
    <div className="install-app">
      <button type="button" className="install-app__button" onClick={() => void install()}>
        <span aria-hidden="true">＋</span>
        <span><strong>Instalar Alexia</strong><small>Abrir sin barra del navegador</small></span>
      </button>
      {instructions && (
        <p className="install-app__instructions" role="status">
          {apple
            ? 'Haz clic en Compartir y después «Agregar a pantalla de inicio».'
            : 'Abre el menú del navegador y haz clic en «Instalar aplicación» o «Agregar a pantalla de inicio».'}
        </p>
      )}
    </div>
  );
}
